import { system } from "@/theme";
import styled from "@emotion/styled";
import escapeRegExp from "lodash/escapeRegExp";
import type { ClipboardEventHandler } from "react";

const HighlightMark = styled.mark`
  font-weight: 600;
  color: ${(p) => p.color};
  background-color: transparent;
`;

export type HighlightedTextProps = {
  text: string;
  highlight: string;
  color?: string;
};

export const handlePlainCopy: ClipboardEventHandler = (e) => {
  const selection = window.getSelection();
  if (!selection) return;

  // Extract only the *text* of the selection (no spans)
  const text = selection.toString();

  e.preventDefault();
  e.clipboardData.setData("text/plain", text);
};

/**
 * Wraps any matching text in a mark element
 */
export const HighlightedText = ({ text, highlight, color = system.trafficGreen }: HighlightedTextProps) => {
  const parts = text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <HighlightMark
            key={i}
            color={color}
          >
            {part}
          </HighlightMark>
        ) : (
          part
        ),
      )}
    </>
  );
};
